import React from "react";
import {
  View,
  Text,
  StyleSheet,
  ImageBackground,
  ImageSourcePropType,
  useWindowDimensions,
} from "react-native";
import QRCode from "react-qr-code";
import { Color } from "../../types";
import { useMemo } from "react";
import { sample } from "lodash";
import { TeamworksWordmark } from "../components/TeamworksLogo";
import { useDeviceId } from "../providers/DeviceProvider";
import background1 from "../../assets/setup-background-1.jpg";
import background2 from "../../assets/setup-background-2.jpg";
import background3 from "../../assets/setup-background-3.jpg";
import background4 from "../../assets/setup-background-4.jpg";
import { useTranslation } from "react-i18next";
import appConfig from "../../app.config";
import { config } from "../config";
import { Spacer } from "../components/ViewComponents";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";

interface Background {
  data: ImageSourcePropType;
  color: Color;
}

const backgrounds: Background[] = [
  {
    data: background1,
    color: "#3F5629" as Color,
  },
  {
    data: background2,
    color: "#041724" as Color,
  },
  {
    data: background3,
    color: "#D15539" as Color,
  },
  {
    data: background4,
    color: "#C93F2C" as Color,
  },
];

const makeStyles = (theme: ThemeOptions) =>
  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: "row",
      flexGrow: 1,
      alignItems: "center",
    },
    column: {
      flex: 1,
      flexDirection: "column",
      flexGrow: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    logo: {
      width: theme.scaled(400),
      height: theme.scaled(100),
    },
    text: {
      color: theme.colors.white,
      fontSize: theme.fontSize.body,
      textShadowColor: theme.colors.black,
      textShadowOffset: { width: 0, height: 0 },
      textShadowRadius: 3,
    },
    qrWrapper: {
      backgroundColor: theme.colors.white,
      padding: theme.spacing.medium,
      paddingBottom: 0,
    },
    versionText: {
      color: "rgba(0, 0, 0, 0.5)",
      fontSize: theme.fontSize.small,
      textAlign: "right",
      paddingTop: theme.spacing.xsmall,
      paddingBottom: theme.spacing.small,
    },
  });

export const SetupScreen = () => {
  const theme = useTheme();
  const styles = makeStyles(theme);
  const background = useMemo(() => sample(backgrounds)!, []);
  const deviceId = useDeviceId();
  const { width, height } = useWindowDimensions();
  const { t } = useTranslation("SetupScreen");

  const setupUrl = `${config.cmsBaseUrl}/devices?createDeviceId=${deviceId}`;

  if (config.isDevelopment) {
    console.log("SETUP URL:", setupUrl);
  }

  return (
    <ImageBackground
      resizeMode="cover"
      source={background.data}
      imageStyle={{ width, height }}
      style={[styles.container, { backgroundColor: background.color }]}
    >
      <View style={styles.column}>
        <View>
          <TeamworksWordmark style={styles.logo} color={theme.colors.white} />
          <Spacer size="medium" />
          <Text style={styles.text}>
            {t("Scan the QR code on your camera app")}
          </Text>
        </View>
      </View>
      <View
        style={{
          width: theme.iconSize.small,
          height: "50%",
          backgroundColor: theme.colors.white,
        }}
      />
      <View style={[styles.column]}>
        <View style={styles.qrWrapper}>
          <QRCode value={setupUrl} size={theme.scaled(250)} />
          <Text style={styles.versionText}>v{appConfig.version}</Text>
        </View>
      </View>
    </ImageBackground>
  );
};
